<script setup lang="ts">
import { useStore } from '@/core/store'
const loggedInUser = useStore().username
</script>

<template>
  <div class="container">
    <div class="header">
      <h1>Dashboard</h1>
      <h3>
        logged in as <span>{{ loggedInUser }}</span>
      </h3>
    </div>

    <div class="grid">
      <router-link to="/spectra" class="card">
        <h2>Spectra</h2>
        <p>Import and manage spectra</p>
      </router-link>

      <router-link to="/collections" class="card">
        <h2>Collections</h2>
        <p>Create and manage collections</p>
      </router-link>

      <router-link to="/tasks" class="card">
        <h2>Tasks</h2>
        <p>Monitor tasks</p>
      </router-link>

      <router-link to="/servers" class="card">
        <h2>Servers</h2>
        <p>Add and manage servers</p>
      </router-link>

      <router-link to="/files" class="card">
        <h2>Files</h2>
        <p>Browse and manage files</p>
      </router-link>

      <router-link to="/news" class="card">
        <h2>News</h2>
        <p>Write and manage news</p>
      </router-link>

      <router-link to="/versions" class="card">
        <h2>Versions</h2>
        <p>Manage versions</p>
      </router-link>

      <router-link to="/users" class="card">
        <h2>Users</h2>
        <p>Manage users</p>
      </router-link>

      <router-link to="/roles" class="card">
        <h2>Roles</h2>
        <p>Manage roles</p>
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: space-between;
  color: #2253a0;

  h3 {
    outline: 1px solid #2253a0;
    padding: 7px;
    border-radius: 5px;

    span {
      color: var(--theme-text);
      font-weight: bold;
    }
  }
}

.container {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.card {
  background: var(--theme-panel);
  color: var(--theme-color);
  padding: 20px;
  border-radius: 5px;
  border: 1px solid var(--theme-border-color);
  transition:
    background 0.3s,
    border 0.3s,
    transform 0.3s;

  &:hover {
    background: var(--theme-panel-secondary);
    border: 1px solid #2253a0;
    transform: scale(1.02);
  }

  p {
    font-size: 0.9rem;
  }
}
</style>
